/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { InfoCircleFilled, SearchOutlined, WarningOutlined } from '@ant-design/icons'
import { Col, Row, Input, Tabs, Badge, Tooltip } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { SupplierInvoiceListReq, SupplierInvoiceListData, CountReq } from 'Store/supplier-invoice/types'
import { getCountInvoiceAPI, supplierInvoiceListAPI } from 'Store/supplier-invoice/api'
import {
  selectSupplierInvoiceList,
  selectSupplierInvoiceListEvent,
  selectSupplierInvoiceActionEvent,
  selectInvoiceCountData,
} from 'Store/supplier-invoice/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { clearEventAction } from 'Store/supplier-invoice/actions'
import { clearEventAction as clearGrnEventAction } from 'Store/grn/actions'
import {
  formatDateWithoutTime,
  getShippingTypes,
  getSupplierInvoiceStatus,
  numberWithComma,
  toDateQuery,
} from 'helpers/format'
import { ExpireDate, StatusTag } from 'Components/utilities'
import {
  menuSupplierInvoicePendingStatus,
  menuSupplierInvoiceStatus,
  SupplierInvoiceStatus,
} from 'helpers/constanst'
import { TableListPage } from 'Components/common/Table'
import { PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import SupplierInvoiceDetail from './detail'
import EventModal from 'Components/modal/EventModal'
import { Pagination } from 'Components/Pagination'
import { RangeDateItem } from 'Components/form'
import theme from 'Components/common/Theme'
const { TabPane } = Tabs

type Props = {} & ReduxProps

const SupplierInvoice: React.FunctionComponent<Props> = props => {
  const { currentUser, listEvent, list, event, countData } = props
  const dispatch = useDispatch()
  const [detailDrawer, setDetailDrawer] = useState(false)
  const [selectedID, setSelectedID] = useState(0)
  const [pageMode, setPageMode] = useState('create' as 'create' | 'edit' | 'deleted')

  const [filter, setFilter] = useState({
    keyword: '',
    status: '',
    start_date: '',
    end_date: '',
    order_by: 'sale_order_id',
    sort: 'desc',
    second_status: SupplierInvoiceStatus.WAITING,
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })
  const meta = list.meta
  const datas = list.data

  const onGetList = (): void => {
    const req: SupplierInvoiceListReq = {
      keyword: filter.keyword,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      start_date: toDateQuery(filter.start_date),
      end_date: toDateQuery(filter.end_date),
      payment_status: filter.status == SupplierInvoiceStatus.WAITING ? filter.second_status : filter.status,
      order_by: filter.order_by || 'sale_order_id',
      sort: filter.sort || 'desc',
    }
    // if (filter.status) {
    //   req['status'] = filter.status
    // }
    dispatch(supplierInvoiceListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onCount = (): void => {
    const req: CountReq = {}
    dispatch(getCountInvoiceAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
      // onGetConfig()
    }
  }, [pagination])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    onCount()
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const handleChangeDate = (statDate: string, endDate: string) => {
    setFilter({
      ...filter,
      start_date: statDate,
      end_date: endDate,
    })
  }

  const onOpenDetailDrawer = () => {
    setDetailDrawer(true)
  }

  const onCloseDetailDrawer = () => {
    setDetailDrawer(false)
  }

  const onClickViewDetail = (id: number) => {
    setPageMode('edit')
    setSelectedID(id)
    onOpenDetailDrawer()
  }

  const onSuccess = () => {
    onCloseDetailDrawer()
    onGetList()
    clearEvent()
    onCount()
  }

  const onPaymentSuccess = () => {
    onGetList()
    clearEvent()
    onCount()
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
    dispatch(clearGrnEventAction())
  }

  const onDeleteSuccess = (): void => {
    clearEvent()
    onGetList()
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const renderStatus = (status: string) => {
    const statusResult = getSupplierInvoiceStatus(status)
    return <StatusTag text={statusResult.text} color={statusResult.color} />
  }

  const renderPaymentDate = (value: string, record: SupplierInvoiceListData) => {
    const isPending =
      record.payment_status === SupplierInvoiceStatus.WAITING ||
      record.payment_status === SupplierInvoiceStatus.PATIAL
    return isPending && value ? (
      <ExpireDate date={value || ''} />
    ) : value ? (
      formatDateWithoutTime(value || '')
    ) : (
      '-'
    )
  }

  const columns = [
    {
      title: 'ลำดับ',
      dataIndex: 'no',
      key: 'no',
      render: (value: any, record: any, index: number) => {
        return index + 1 + (pagination.Page - 1) * pagination.RowPerPage
      },
      width: '60px',
    },
    {
      title: 'เลขที่สั่งซื้อ',
      dataIndex: 'sale_order_no',
      key: 'sale_order_no',
      width: '180px',
      render: (val: string, record: SupplierInvoiceListData) => (
        <LinkNo onClick={() => onClickViewDetail(record.sale_order_id)}>{val}</LinkNo>
      ),
      sorter: true,
    },
    {
      title: 'เลขที่ใบเสนอราคา',
      dataIndex: 'quotation_no',
      key: 'quotation_no',
      width: '180px',
      sorter: true,
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'customer_name',
      key: 'customer_name',
      sorter: true,
    },
    {
      title: <TextRight>จำนวน/รายการ</TextRight>,
      dataIndex: 'total_quantity',
      key: 'total_quantity',
      render: (val: number) => {
        return <TextRight>{numberWithComma(val)}</TextRight>
      },
      sorter: true,
    },
    {
      title: <TextRight>ราคารวม</TextRight>,
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (val: number) => {
        return <TextRight>{numberWithComma(val, true)}</TextRight>
      },
      sorter: true,
    },
    {
      title: 'การจัดส่ง',
      dataIndex: 'delivery_channel',
      key: 'delivery_channel',
      render: (val: string) => getShippingTypes([val]),
      sorter: true,
    },
    {
      title: 'วันที่จัดส่ง',
      dataIndex: 'delivered_dt',
      key: 'delivered_dt',
      render: (val: string) => formatDateWithoutTime(val || ''),
      sorter: true,
    },
    {
      title: 'กำหนดชำระ',
      dataIndex: 'expiry_dt',
      key: 'expiry_dt',
      render: (value: any, record: any) => {
        return renderPaymentDate(value, record)
      },
      sorter: true,
    },
    {
      title: 'สถานะ',
      key: 'payment_status',
      dataIndex: 'payment_status',
      render: renderStatus,
      sorter: true,
    },
  ]

  const DetailDrawer = (
    <SupplierInvoiceDetail
      id={selectedID}
      visible={detailDrawer}
      onCloseDrawer={onCloseDetailDrawer}
      onSuccess={onSuccess}
      onPaymentSuccess={onPaymentSuccess}
    />
  )

  const LoadingModal = (
    <EventModal
      event={[event]}
      enable={pageMode === 'deleted'}
      successCalback={onDeleteSuccess}
      errorCalback={clearEvent}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={24}>
          <Row gutter={[8, 8]}>
            <Col md={8} xs={24}>
              <SearchInput
                placeholder="ค้นหาเลขที่ใบเสนอราคา, เลขที่สั่งซื้อ ,ชื่อลูกค้า"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col xs={24} md={8}>
              <RangeDateItem
                placeHolder={['วันที่จัดส่งสำเร็จเริ่มต้น', 'สิ้นสุด']}
                onChange={handleChangeDate}
                startDate={filter.start_date}
                endDate={filter.end_date}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
    />
  )

  const onChangeTab = (key: string) => {
    onFilter('status', key)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const onChangeSecondTab = (key: string) => {
    onFilter('second_status', key)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const renderTitle = (name: string, key: string) => {
    const newcountData = countData as any
    const count = newcountData?.[key || 'all'] || 0
    // const count = 0
    return (
      <span>
        {name} <Badge count={count} showZero={false} overflowCount={9999} />
      </span>
    )
  }

  const renderSecondTitle = (name: string, key: string) => {
    const newcountData = countData as any
    const count = newcountData?.[key || 'all'] || 0
    // const count = 0
    return (
      <span>
        {/* {key === SupplierInvoiceStatus.WAITING ? '' : `(${count})`} */}
        {key === SupplierInvoiceStatus.EXPIRED ? (
          <Tooltip
            placement="right"
            title="ใกล้ถึงกำหนดชำระ คือ รายการเรียกเก็บหนี้ที่ใกล้ถึงกำหนดชำระอีก 3 วันข้างหน้า และรายการที่เกินกำหนดชำระ"
          >
            <WarningOutlined color={theme.colors.primary} />
            {name} ({count})
          </Tooltip>
        ) : (
          `${name} (${count})`
        )}
      </span>
    )
  }

  const getTab = () => {
    return (
      <Tabs onChange={onChangeTab} activeKey={filter.status} type="line">
        {menuSupplierInvoiceStatus.map((item: any) => {
          return (
            <TabPane tab={renderTitle(item.name, item.value)} key={item.value}>
              {item.value == SupplierInvoiceStatus.WAITING && getSecondTab()}
            </TabPane>
          )
        })}
      </Tabs>
    )
  }

  const getSecondTab = () => {
    return (
      <Tabs onChange={onChangeSecondTab} activeKey={filter.second_status} type="card">
        {menuSupplierInvoicePendingStatus.map((item: any) => {
          return <TabPane tab={renderSecondTitle(item.name, item.value)} key={item.value}></TabPane>
        })}
      </Tabs>
    )
  }

  return (
    <>
      <HomePageLayout selected="supplier-invoice" title="รายการเรียกเก็บหนี้" label="">
        {getTab()}
        {FilterContent}
        <TableListPage
          columns={columns}
          datas={datas}
          isLoading={listEvent.IsLoading}
          paginationContent={PaginationContent}
          size="middle"
          onSort={onSort}
        />
        {LoadingModal}
        {DetailDrawer}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    list: selectSupplierInvoiceList(state),
    listEvent: selectSupplierInvoiceListEvent(state),
    event: selectSupplierInvoiceActionEvent(state),
    countData: selectInvoiceCountData(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`
const TextRight = styled.div`
  text-align: right;
  margin-right: 20px;
`

const LinkNo = styled.div`
  cursor: pointer;
  text-decoration: underline;
  font-family: ${theme.fontFamily.bold};
  color: ${theme.colors.primary};
`

export default connect(mapStateToProps)(SupplierInvoice)
